import { onTransitionEnd } from '../../helpers/ontransitionend';

export default class HeroSlider {
    constructor() {
        this.$container = document.querySelector('.hero--slider');
        this.$slides = document.querySelectorAll('.hero__slide');

        if (!this.$container || this.$slides.length < 2) {
            return;
        }

        this.init();
    }

    init() {
        this.appendNavigation();
        this.eventToggleSlide();
    }

    appendNavigation() {
        const $navContainer = this.$container.querySelector('.container');
        const buttons = [...this.$slides].map((_, index) => `<button class="hero__pagination-button ${index === 0 ? 'hero__pagination-button--current' : ''}"></button>`);
        const output = `
            <div class="hero__pagination">
                ${buttons.join('')}
            </div>
        `;

        $navContainer.insertAdjacentHTML('beforeend', output)
    }

    /**
     * Changeing slides
     * @param index - index of a slide that should appear on a screen
     */
    toggleSlide(index) {
        const $buttons = this.$container.querySelectorAll('.hero__pagination-button');

        $buttons.forEach(($btn) => $btn.classList.remove('hero__pagination-button--current'));

        this.$slides.forEach(($slide) => {
            if (+$slide.getAttribute('data-index') === index) {
                this.changeSlideWithAnimation($slide);

                $buttons[index].classList.add('hero__pagination-button--current');
            }
        });
    }

    /**
     * Hide current visible slide, and show new with animation
     */
    changeSlideWithAnimation($slide) {
        const [$currentVisible] = [...this.$slides].filter(($node) => !$node.classList.contains('hero__slide--hidden'));
        if ($currentVisible) { // prevents error when tab is not active
            $currentVisible.classList.add('hero__slide--hidden');
            onTransitionEnd($currentVisible).then(() => {
                $currentVisible.style.display = 'none';
                $slide.style.display = 'flex';
                $slide.classList.remove('hero__slide--hidden');
            });
        }
    }

    eventToggleSlide() {
        const $buttons = this.$container.querySelectorAll('.hero__pagination-button');

        $buttons.forEach(($btn, index) => {
            $btn.addEventListener('click', () => {
                this.toggleSlide(index);
            });
        });

        let touchStart = 0, touchEnd = 0, currentIndex = 0, sliderItems = $buttons.length;

        this.$container.addEventListener('touchstart', (e) => {
            touchStart = e.changedTouches[0].screenX;
        })

        this.$container.addEventListener('touchend', (e) => {
            touchEnd = e.changedTouches[0].screenX;

            clearInterval(triggerAutoSlide);
            triggerAutoSlide = setInterval(() => {
                currentIndex++;
                if (currentIndex >= sliderItems) currentIndex = 0;
                this.toggleSlide(currentIndex);
            }, 7000);

            if (Math.abs(touchStart - touchEnd) > 100) { // execute if swipe was longer than 100px
                if (touchEnd > touchStart) {
                    currentIndex--;
                    if (currentIndex < 0) currentIndex = sliderItems - 1;
                }
                if (touchEnd < touchStart) {
                    currentIndex++;
                    if (currentIndex >= sliderItems) currentIndex = 0;
                }
                this.toggleSlide(currentIndex);
            }
        })

        let triggerAutoSlide = setInterval(() => {
            currentIndex++;
            if (currentIndex >= sliderItems) currentIndex = 0;
            this.toggleSlide(currentIndex);
        }, 7000);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/hero-slider/HeroSlider.js